/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { Theme } from 'styles/theme';

export const Wrapper = styled.div<{ theme: Theme }>`
  .slick-slider {
    user-select: text;
  }
    
  .card-wrapper {
    padding: 0 24px;
  }

  @media (${breakpoint.mdMin}) and (${breakpoint.hybridMax}) {
    margin-left: -24px;
    margin-right: -24px;
  }

  @media (${breakpoint.lgMin}) {
    .article-card {
      .card-title {
        font-size: 3.75rem;
      }
    }
  }

  @media (${breakpoint.hybridMin}) {
    .card-wrapper {
      padding: 0;
    }
  }
`;
